import React, { Component } from 'react';
import { Container, Form, Col, Button, Table, Row, Modal } from 'react-bootstrap';
import axios from 'axios'
import { AdminNav, Loading } from '../../helpers';

import { convertRiceTypeENToTH, convertRiceTypeTHToEN, addCommaInNumber, convertRiceTypeENToENFull, updateState, evalSurveyRequest, evalCheckWeight, directConvert } from '../../helpers/function';
import {
  exportExcelNew, exportExcelParboild, exportExcelMultipleNew, exportExcelMultipleParboild
} from '../../helpers/functionForStats'
import './StyleStatistics.css'
import { isArray } from 'lodash';
//Found bug

function remove_double_spacing(s) {
  if (s != undefined) {
    return s?.replaceAll('  ', ' ').trim()
  } else {
    return ''
  }
}
function remove_go_down(s) {
  if (s != undefined) {
    return s?.replaceAll('godown', '')
  } else {
    return ''
  }
}
function modifier_license_length(s) {
  if (s != undefined) {
    return `${s?.slice(8, s.length)}`
  } else {
    return ''
  }
}
function modifier_loading(s) {
  if (s == 'Container NO') {
    return '/'
  } else {
    return ''
  }
}
function modifier_vehicle(s) {
  if (s != undefined) {
    return s?.replaceAll('S.S.  ', '')?.replaceAll('“', '')?.replaceAll('”', '')
  } else {
    return ''
  }
}

export class Statistic extends Component {
  constructor(props) {
    super(props);
    this.state = {
      riceTitles: null,
      startDate: null,
      endDate: null,
      multipleStartDate: null,
      multipleEndDate: null,
      showErrorModal: false,
      modalContent: 'empty',
      riceTypeIDAndName: {},
      viewAllCompany: ''
    }
    this.renderCompany = this.renderCompany.bind(this)
  }

  componentWillMount() {
    let viewAllRiceTitles = fetch(`https://backend1.riceinspections.com/testBC`).then((res) => {
      return res.json()
    })
    let viewAllRiceTypeIDAndNamePromise = fetch('https://backend1.riceinspections.com/testE').then((res) => {
      return res.json()
    })
    let viewAllCompany = fetch('https://backend1.riceinspections.com/testD').then((res) => { return res.json() })

    Promise.all([viewAllRiceTitles, viewAllRiceTypeIDAndNamePromise, viewAllCompany]).then((res) => {
      viewAllRiceTitles = res[0]
      viewAllRiceTypeIDAndNamePromise = res[1]

      let riceTitleArr = []
      viewAllRiceTitles.map((title) => {
        riceTitleArr.push({
          title,
          checked: false,
        })
      })
      this.setState({
        "riceTitles": riceTitleArr,
        "riceTypeIDAndName": viewAllRiceTypeIDAndNamePromise,
        "viewAllCompany": res[2]
      })
    })

  }

  renderCompany(companyObj) {
    // console.log(this.state.viewAllCompany)
    let viewAllCompany = this.state.viewAllCompany
    let outputCompany = null
    Object.values(viewAllCompany).map((companyData) => {
      if (companyData['companyNameTH'].replace(/\s/g, '').trim() == companyObj.replace(/\s/g, '').trim()) {
        outputCompany = companyData['companyNameEN']
      }
    })
    if (companyObj == 'ไทยฮาจำกัด') {
      outputCompany = 'THAI HA PUBLIC CO., LTD.'
    } else if (companyObj == 'ไทยฟ้า(2511)จำกัด') {
      outputCompany = 'THAI HUA (2511) CO., LTD.'
    }
    if (outputCompany) {
      return outputCompany
    } else {
      return companyObj
    }
  }

  HandleChange = (e) => {
    console.log(e.target.value)
    this.setState({
      ...this.state,
      [e.target.id]: e.target.value,
    })
  }
  HandleSubmit = (isParboiled) => {
    const { startDate, riceTypeIDAndName } = this.state;
    if (startDate === null) {
      // this.toggleModal()
      alert('เกิดข้อผิดพลาด')
    } else {
      let saveDate = ''


      let viewAllSurveyRequestSheetByDatePromise = fetch(`https://backend1.riceinspections.com/testAA?timeValue=${startDate || new Date()}`).then((res) => { return res.json() })
      let viewAllCheckWeightCompletePromise = axios.post('https://backend1.riceinspections.com/testHA', { data: { 'timeValue': startDate || new Date() }, }).then((res) => { return res['data'] })
      let viewAllCertificateCompletePromise = axios.post("https://backend1.riceinspections.com/testGE", { data: { timeValue: startDate, } }).then((res) => { return res['data'] })

      let RequestComplete = fetch(`https://backend1.riceinspections.com/testA?timeValue=${startDate}`).then((res) => { return res.json() })
      let RequestJobComplete = fetch('https://backend1.riceinspections.com/testB').then((res) => { return res.json() })
      let viewAllOfficer = fetch('https://backend1.riceinspections.com/testC').then((res) => { return res.json() })
      let viewAllCompany = fetch('https://backend1.riceinspections.com/testD').then((res) => { return res.json() })

      Promise.all([RequestComplete, RequestJobComplete, viewAllOfficer, viewAllCompany, viewAllSurveyRequestSheetByDatePromise, viewAllCheckWeightCompletePromise, viewAllCertificateCompletePromise])
        .then((res) => {
          RequestComplete = res[0] || {}
          RequestJobComplete = res[1] || {}
          viewAllOfficer = res[2] || {}
          viewAllCompany = res[3] || {}
          let viewAllSurveyRequestSheetByDate = res[4] || {}
          let viewAllCheckWeightComplete = res[5] || {}
          let viewAllCertificateComplete = res[6] || {}

          let newAllCertificateComplete = []
          //i want to concat all certificate in same array
          viewAllCertificateComplete.map((o) => {
            o.map((i) => {
              // console.log(i['No'])
              newAllCertificateComplete.push(i)
            })
          })

          let dataForUpdate = updateState(RequestComplete, RequestJobComplete, viewAllOfficer, viewAllCompany)
          let newArr = dataForUpdate['0']
          let pairColor = dataForUpdate['2']
          let arr = evalSurveyRequest(viewAllSurveyRequestSheetByDate, RequestJobComplete)
          let newObjArr = evalCheckWeight(viewAllCheckWeightComplete, arr)


          let arrWeight = []
          arr.map((o) => {
            let targetDescription = []
            if(isArray(o['description'])){
              targetDescription = o['description']
            }else{
              targetDescription = Object.values(o['description'])
            }
            targetDescription.map((i, idx) => {
              // if(i['licenseID'] == '0308116549922'){
              //   console.log(o)
              // }
              // console.log(this.renderCompany(o['companyID']),o['godown'],i['LoaingType'],i['subID'],i['licenseID'],o['jobID'],i[`vehicleName${idx}`],i['destinationCity'],i['wtf'],i['quantity'])

              // let a = { "0": { "trafficType": "1006.30.30-003", "des": "", "riceEN": "WhiteGlutinousRice10" }, "1": { "trafficType": "1006.20.90-607", "des": "", "riceEN": "BlackCargoRiceSuperbQuality" }, "2": { "trafficType": "1006.30.40-001", "des": "", "riceEN": "ThaiFragrantWhiteRice100" }, "3": { "trafficType": "1006.20.90-613", "des": "", "riceEN": "RedCargoRiceSuperbQuality" }, "4": { "trafficType": "1006.30.99-001", "des": "", "riceEN": "ThaiFragrantWhiteRice100" }, "5": { "trafficType": "1006.20.90-619", "des": "", "riceEN": "BlackGlutinousCargoRiceStandardQuality" }, "6": { "trafficType": "1006.20.90-608", "des": "", "riceEN": "BlackCargoRicePrimeQuality" }, "7": { "trafficType": "1006.20.90-614", "des": "", "riceEN": "RedCargoRicePrimeQuality" }, "8": { "trafficType": "1006.20.90-501", "des": "" }, "9": { "trafficType": "1006.20.90-001", "des": "", "riceEN": "ThaiFragrantCargoRice100" }, "10": { "trafficType": "1006.20.90-606", "des": "", "riceEN": "BlackCargoRicePrimeQuality" }, "11": { "trafficType": "1006.20.90-612", "des": "", "riceEN": "RedCargoRicePrimeQuality" }, "12": { "trafficType": "1006.30.91-002", "des": "" }, "13": { "trafficType": "1006.30.99-018", "des": "", "riceEN": "WhiteRice25" }, "14": { "trafficType": "1006.30.99-012", "des": "", "riceEN": "WhiteRice5" }, "15": { "trafficType": "1006.30.30-006", "des": "" }, "16": { "trafficType": "1006.30.99-007", "des": "" }, "17": { "trafficType": "1006.40.90-006", "des": "WhiteBrokenRiceA1Super", "riceEN": "WhiteBrokenRiceA1Super" }, "18": { "trafficType": "1006.40.90-019", "des": "", "riceEN": "WhiteGlutinousBrokenRiceA1" }, "19": { "trafficType": "1006.40.90-602", "des": "", "riceEN": "WhiteGlutinousBrokenRiceAsPerSample" }, "20": { "trafficType": "1006.30.91-001", "des": "", "riceEN": "ParboiledRice100Sorted" }, "21": { "trafficType": "1006.30.91-600", "des": "", "riceEN": "ParboiledRiceAsPerSample" }, "22": { "trafficType": "1006.30.99-013", "des": "", "riceEN": "WhiteRice10" }, "23": { "trafficType": "1006.30.91-003", "des": "", "riceEN": "ParboiledRice5Sorted" }, "24": { "trafficType": "1006.40.90-005", "des": "", "riceEN": "ThaiFragrantWhiteBrokenRiceA1Super" }, "25": { "trafficType": "1006.20.90-018", "des": "", "riceEN": "CargoRice100GradeB" }, "26": { "trafficType": "1006.20.90-616", "des": "" }, "27": { "trafficType": "1006.30.99-010", "des": "", "riceEN": "WhiteRice100B" }, "28": { "trafficType": "1006.30.99-601", "des": "", "riceEN": "WhiteRiceAsPerSample" }, "29": { "trafficType": "1006.40.90-012", "des": "", "riceEN": "ThaiFragrantWhiteBrokenRiceA1Super" }, "30": { "trafficType": "1006.20.90-604", "des": "", "riceEN": "SpecialMixedCargoRiceAsPerSample" }, "31": { "trafficType": "1006.20.90-504", "des": "", "riceEN": "CargoRiceAsPerSample" }, "32": { "trafficType": "1006.20.90-615", "des": "", "riceEN": "RedCargoRiceSuperbQuality" }, "33": { "trafficType": "1006.40.90-010", "des": "", "riceEN": "ThaiFragrantWhiteBrokenRiceA1ExtraSuper" }, "34": { "trafficType": "1006.30.99-003", "des": "", "riceEN": "ThaiFragrantWhiteRice5" }, "35": { "trafficType": "1006.30.99-600", "des": "", "riceEN": "ThaiFragrantWhiteRiceAsPerSample" }, "36": { "trafficType": "1006.20.90-506", "des": "", "riceEN": "ThaiFragrantCargoRice100" }, "37": { "trafficType": "1006.20.90-633", "des": "", "riceEN": "BlackCargoRiceAsPerSample" }, "38": { "trafficType": "1006.30.99-014", "des": "", "riceEN": "WhiteRice15" }, "39": { "trafficType": "1006.20.90-600", "des": "", 'riceEN': 'CargoParboiledRiceAsPerSample' }, "40": { "trafficType": "1006.20.90-601", "des": "", "riceEN": "ThaiFragrantCargoRiceAsPerSample" }, "41": { "trafficType": "1006.30.99-603", "des": "", "riceEN": "SpecialMixedRiceAsPerSample" }, "42": { "trafficType": "1006.20.90-630", "des": "" }, "43": { "trafficType": "1006.20.90-618", "des": "", "riceEN": "BlackGlutinousCargoRiceBestQuality" }, "44": { "trafficType": "1006.40.90-018", "des": "", "riceEN": "ParboiledBrokenRiceA1" }, "45": { "trafficType": "1006.40.90-600", "des": "", "riceEN": "WhiteBrokenRiceC1AsPerSample" }, "46": { "trafficType": "1006.30.30-004", "des": "", "riceEN": "WhiteGlutinousRice10" }, "47": { "trafficType": "1006.40.90-001", "des": "", "riceEN": "CargoBrokenRiceAsPerSample" }, "48": { "trafficType": "1006.20.90-632", "des": "", "riceEN": "BLACKCARGORICEASPERSAMPLE" }, "49": { "trafficType": "1006.30.91-007", "des": "", "riceEN": "ParboiledRice15" }, "50": { "trafficType": "1006.30.91-004", "des": "", "riceEN": "ParboiledRice5" }, "51": { "trafficType": "1006.20.90-010", "des": "", "riceEN": "CargoRice5" }, "52": { "trafficType": "1006.30.99-009", "des": "", "riceEN": "WhiteRice100A" }, "53": { "trafficType": "1006.20.90-609", "des": "", "riceEN": "BlackCargoRiceSuperbQuality" }, "54": { "trafficType": "1006.30.99-015", "des": "" }, "55": { "trafficType": "1006.30.99-502", "des": "", "riceEN": "ThaiFragrantWhiteRice100" }, "56": { "trafficType": "1006.30.40-500", "des": "", "riceEN": "ThaiFragrantWhiteRice100" }, "57": { "trafficType": "1006.40.90-004", "des": "", "riceEN": "WhiteBrokenRiceA1ExtraSuper" }, "58": { "trafficType": "1006.30.99-602", "des": "", "riceEN": "WhiteRiceAsPerSample" }, "59": { "trafficType": "1006.20.90-610", "des": "", "riceEN": "BlackCargoRiceAsPerSample" }, "60": { "trafficType": "1006.20.90-622", "des": "", "riceEN": 'BlackGlutinousCargoRiceAsPerSample' }, "61": { "trafficType": "1006.20.90-631", "des": "" }, "62": { "trafficType": "1006.20.90-605", "des": "", "riceEN": "RedCargoRiceSuperbQuality" }, "63": { "trafficType": "1006.30.30-601", "des": "", "riceEN": "SPECIALMIXEDGLUTINOUSRICEASPERSAMPLE" }, "64": { "trafficType": "1006.30.99-023", "des": "", "riceEN": "WhiteRiceEnrichedVitaminAsPerSample" }, "65": { "trafficType": "1006.30.40-006", "des": "", "riceEN": "ThaiFragrantWhiteRice15" }, "66": { "trafficType": "1006.40.90-003", "des": "" }, "67": { "trafficType": "1006.30.99-022", "des": "", "riceEN": "WhiteRice45" }, "68": { "trafficType": "1006.30.99-011", "des": "", "riceEN": "WhiteRice100C" }, "69": { "trafficType": "1006.30.99-005", "des": "" }, "70": { "trafficType": "1006.20.90-011", "des": "", "riceEN": "CargoRice10" }, "71": { "trafficType": "1006.40.90-609", "des": "" }, "72": { "trafficType": "1006.20.90-012", "des": "" }, "73": { "trafficType": "1006.20.90-508", "des": "" }, "74": { "trafficType": "1006.20.90-611", "des": "" }, "75": { "trafficType": "1006.20.90-617", "des": "" }, "76": { "trafficType": "1006.20.90-620", "des": "", "riceEN": "BlackGlutinousCargoRiceBestQuality" } }
              // let riceTH = convertRiceTypeTHToEN(i['riceTypeName'], riceTypeIDAndName)
              // Object.values(a).map((riceObj) => {
              //   if (riceObj['trafficType'] == riceTH) {
              //     riceTH = riceObj['riceEN']
              //   }
              // })
              // riceTH = riceTH.toUpperCase()
              // riceTH = directConvert(riceTH)
              let riceTHObj = newAllCertificateComplete.filter(o => o['License'] == i['licenseID'])
              let riceTHSub = riceTHObj.filter(o => o['subID'] == i['subID'])
              let riceTH = 'undefined'
              let No = '00000'
              if (riceTHSub.length > 0) {
                riceTH = i['riceTypeID']
                if(riceTHSub[0]['wtf1']){
                  riceTH = riceTHSub[0]['wtf1']
                }
                No = riceTHSub[0]['No']
              } else {
                riceTH = 'undefined'
              }
              console.log(o)

              let filtered_parboiled = 'ไม่พบใบอนุญาต'
              if (i['licenseID'] != '9999999999999') {
                filtered_parboiled = riceTH?.indexOf('PARBOILED') == -1 ? false : true
              }
              else {
                console.log('ไม่พบใบอนุญาต',i['licenseID'] )
              }


              // console.log(o)
              if (filtered_parboiled == isParboiled && Number.isFinite(i['quantity'])) {
                arrWeight.push({
                  'companyEN': this.renderCompany(o['companyID']),
                  'godown': o['godown'],
                  'checkWeight': {
                    'LoaingType': i['LoaingType'],
                    'pricePerUnit': i['PricePerUnit'],
                    'exchangeRate': i['ExchangeRate'],
                    'riceTypeName': i['riceTypeName']
                  },
                  'subID': i['subID'],
                  'licenseID': i['licenseID'],
                  'jobID': o['jobID'],
                  'vehicleName': i[`vehicleName${idx}`],
                  'destinationCity': i['destinationCity'],
                  'wtf1': riceTH,
                  'No' : No,
                  'TotalNett': `${((Math.round((i['quantity']) * 100)) / 100) * 1000}`,
                })
              }
            })
          })
 
          let ranked_by_license = arrWeight
          console.log(ranked_by_license) 
          exportExcelNew(ranked_by_license, remove_double_spacing, remove_go_down, modifier_license_length, modifier_loading, modifier_vehicle, startDate)

        })
    }
  }
  HandleMultipleSubmit = () => {
    const { multipleStartDate, multipleEndDate } = this.state;
    if (multipleStartDate == null || multipleEndDate == null) {
      alert('เกิดข้อผิดพลาด')
    } else {
      let arrDate = []
      console.log(multipleEndDate, multipleStartDate)
      let groupStartDay = multipleStartDate.split('-')
      let groupEndDay = multipleEndDate.split('-')
      let dayStartDay = groupStartDay[2]
      let dayEndDay = groupEndDay[2]
      for (let i = dayStartDay; i < parseInt(dayEndDay); i++) {
        if (i < 10) {
          arrDate.push(`${groupStartDay[0]}-${groupStartDay[1]}-0${parseInt(i)}`)
        } else {
          arrDate.push(`${groupStartDay[0]}-${groupStartDay[1]}-${i}`)
        }
      }
      console.log(arrDate)
      let promiseData = []
      arrDate.map((startDate) => {
        promiseData.push(axios.post(
          'https://backend1.riceinspections.com/testGE',
          {
            data: {
              timeValue: startDate,
            },
          }
        ))
      })
      Promise.all(promiseData).then((resData) => {
        console.log(resData)
        let unpack_raw_data = []
        resData.map((o) => {
          if (Array.isArray(o['data'])) {
            o['data'].map((temp) => {
              if (Array.isArray(temp)) {
                temp.map((o_i) => {
                  unpack_raw_data.push(o_i)
                })
              }
            })
          }
        })

        let filtered_unknow_license = unpack_raw_data.filter((o) => { return o['licenseID'] != "9999999999999" })
        let filtered_parboiled = filtered_unknow_license.filter((o) => { return o['wtf1']?.indexOf('PARBOILED') == -1 })
        // console.log(filtered_parboiled)

        let ranked_by_job = filtered_parboiled.sort((a, b) => { return parseInt(a['jobID']) - parseInt(b['jobID']) })
        let ranked_by_license = ranked_by_job.sort((a, b) => {
          if (a['jobID'] == b['jobID'] && a['licenseID'] == b['licenseID']) {
            return parseInt(a['subID']) - parseInt(b['subID'])
          }
        })
        exportExcelMultipleNew(ranked_by_license, remove_double_spacing, remove_go_down, modifier_license_length, modifier_loading, modifier_vehicle, `${multipleStartDate}-${multipleEndDate}`)
      }).catch(err => {
        alert('เกิดปัญหา err 01')
        console.log(err)
      })
    }
  }

  HandleMultipleSubmitParboild = () => {
    const { multipleStartDate, multipleEndDate } = this.state;
    if (multipleStartDate == null || multipleEndDate == null) {
      alert('เกิดข้อผิดพลาด')
    } else {
      let arrDate = []
      let groupStartDay = multipleStartDate.split('-')
      let groupEndDay = multipleEndDate.split('-')
      let dayStartDay = groupStartDay[2]
      let dayEndDay = groupEndDay[2]
      for (let i = dayStartDay; i < parseInt(dayEndDay); i++) {
        if (i < 10) {
          arrDate.push(`${groupStartDay[0]}-${groupStartDay[1]}-0${parseInt(i)}`)
        } else {
          arrDate.push(`${groupStartDay[0]}-${groupStartDay[1]}-${i}`)
        }
      }
      let promiseData = []
      arrDate.map((startDate) => {
        promiseData.push(axios.post(
          'https://backend1.riceinspections.com/testGE',
          {
            data: {
              timeValue: startDate,
            },
          }
        ))
      })
      Promise.all(promiseData).then((resData) => {
        let unpack_raw_data = []
        resData.map((o) => {
          if (Array.isArray(o['data'])) {
            o['data'].map((temp) => {
              if (Array.isArray(temp)) {
                temp.map((o_i) => {
                  unpack_raw_data.push(o_i)
                })
              }
            })
          }
        })

        let filtered_unknow_license = unpack_raw_data.filter((o) => { return o['licenseID'] != "9999999999999" })
        let filtered_parboiled = filtered_unknow_license.filter((o) => { return o['wtf1']?.indexOf('PARBOILED') != -1 })
        let ranked_by_job = filtered_parboiled.sort((a, b) => { return parseInt(a['jobID']) - parseInt(b['jobID']) })
        let ranked_by_license = ranked_by_job.sort((a, b) => {
          if (a['jobID'] == b['jobID'] && a['licenseID'] == b['licenseID']) {
            return parseInt(a['subID']) - parseInt(b['subID'])
          }
        })
        exportExcelMultipleParboild(ranked_by_license, remove_double_spacing, remove_go_down, modifier_license_length, modifier_loading, modifier_vehicle, `${multipleStartDate}-${multipleEndDate}`)
      }).catch(err => {
        alert('เกิดปัญหา err 01')
        console.log(err)
      })
    }
  }

  render() {
    let { riceTitles, showErrorModal } = this.state;
    if (!riceTitles) {
      return (
        <Container>
          <AdminNav></AdminNav>
          <Loading />
        </Container>
      )
    }
    return (
      <Container>
        <AdminNav></AdminNav>
        <div style={{ display: 'flex', alignItem: 'center', backgroundColor: 'gray' }}>
          <p style={{ margin: '0 auto', fontSize: '18px', color: 'white' }}><b>03/02/2566 สามารถดาวน์โหลดได้ถึงวันที่ 31/01/2566 และเพิ่มข้อมูล Cert No. </b></p>
        </div>

        <Form>
          <Row>

            <Col>
              <Form.Label>วันที่</Form.Label>
              <Form.Control
                required
                type="date"
                id="startDate" onChange={this.HandleChange}
              />
            </Col>
          </Row>
        </Form>
        <div className="button-container">
          <Button onClick={() => { this.HandleSubmit(false) }}>ดูสถิติ (ข้าวขาว)</Button>
        </div>
        <div className="button-container" style={{ marginRight: '0.5em' }}>
          <Button onClick={() => { this.HandleSubmit(true) }}>ดูสถิติ (ข้าวนึ่ง)</Button>
        </div>

        <br /><br /><br />
        <br /><br /><br />

        <Form>
          <Row>
            <Col>
              <b>ทดสอบพิกัด</b> <br /><br />
            </Col>
          </Row>

          <Row>
            <Col>
              <Form.Label>วันที่ (เริ่มต้น)</Form.Label>
              <Form.Control
                required
                type="date"
                id="multipleStartDate" onChange={this.HandleChange}
              />
            </Col>
            <Col>
              <Form.Label>วันที่ (สิ้นสุด)</Form.Label>
              <Form.Control
                required
                type="date"
                id="multipleEndDate" onChange={this.HandleChange}
              />
            </Col>
          </Row>
        </Form>
        <div className="button-container">
          <Button onClick={this.HandleMultipleSubmit}>ดูสถิติ (ข้าวขาว)</Button>
        </div>
        <div className="button-container" style={{ marginRight: '0.5em' }}>
          <Button onClick={this.HandleMultipleSubmitParboild}>ดูสถิติ (ข้าวนึ่ง)</Button>
        </div>





      </Container>
    )
  }
}

export default Statistic;
